import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";

export default class RequestCard extends React.Component {
  render() {
    return (
      <div className="requestCard">
        <Link to={"/pedi-tu-usado/"}>
          <div className="content">{this.props.children}</div>
        </Link>
      </div>
    );
  }
}
